import { getViewportState } from "tornis";

export const viewport = {
  data() {
    return {
      viewport: {
        mobile: false,
        tablet: false
      }
    };
  },
  mounted() {
    const state = getViewportState();
    this.viewport.mobile = state.size.x < 600;
    this.viewport.tablet = state.size.x > 600 && state.size.x < 1050;
  }
};
